
<template>
  <div class="store-content">
    <div id="slider-container">
      <Slider />
    </div>
    <div id="most-view">
      <h2 class="list-title">{{$_('our_most_viewed_products').toUpperCase()}}</h2>
      <ProductList type="mostview" />
    </div>
  </div>
</template>

<script>
import Slider from "@/common/components/widget/Slider";
import ProductList from "@/modules/produit/components/ProductList";

import cartService from "@/modules/panier/services/cartService";

export default {
  name: "Home",
  components: {
    Slider,
    ProductList
  },
  computed: {
    getTncli() {
      return this.$store.getters['application/get_application_customer'];
    }
  },
  watch: {
    getTncli(val) {
      cartService.getCurrentCart();
    }
  }
};
</script>

<style scoped>
#slider-container {
  padding: 20px;
}
.list-title {
  padding: 50px 30px;
}
.info-banner {
  width: 100%;
  height: 500px;
  background-color: grey;
}
</style>